import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=170a01dd&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=170a01dd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170a01dd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('170a01dd')) {
      api.createRecord('170a01dd', component.options)
    } else {
      api.reload('170a01dd', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=170a01dd&scoped=true&", function () {
      api.rerender('170a01dd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Kscws8Wm9NqN/JS/comp/DocBox.vue"
export default component.exports